var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSankey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 82,
    viewBox: "0 0 124 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1952",
    "data-name": "Group 1952",
    transform: "translate(-22 -609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1951",
    "data-name": "Group 1951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1787",
    "data-name": "Group 1787",
    transform: "translate(-11805 -7916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1785",
    "data-name": "Group 1785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3252",
    "data-name": "Path 3252",
    d: "M11833,8549h114.652v29.37H11833Z",
    transform: "translate(-0.845 -23.37)",
    fill: "#c2c4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    "data-name": "Path 3253",
    d: "M11833,8549h114.652v31.741H11833Z",
    transform: "translate(-0.845 25.406)",
    fill: "#c2c4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3254",
    "data-name": "Path 3254",
    d: "M11832.157,8616.639s34.568-3.766,63.974-5.22c10.88-.538,21.085-.843,29.9-1.02,14.269-.286,23.981-.188,23.981-.188",
    transform: "translate(-1.777 -48.731)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147858",
    "data-name": "Rectangle 147858",
    width: 6,
    height: 30,
    transform: "translate(11827 8525)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147861",
    "data-name": "Rectangle 147861",
    width: 6,
    height: 33,
    transform: "translate(11951 8607) rotate(180)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147859",
    "data-name": "Rectangle 147859",
    width: 6,
    height: 46,
    transform: "translate(11827 8561)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147860",
    "data-name": "Rectangle 147860",
    width: 6,
    height: 43,
    transform: "translate(11951 8568) rotate(180)",
    fill: "#575757"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSankey);
export default __webpack_public_path__ + "static/media/sankey.c811dc005c2c6e9bfe73e319884224ac.svg";
export { ForwardRef as ReactComponent };